import AbstractInstaller from "../../application/AbstractInstaller";
import MediatorMapping from "../../application/MediatorMapping";
import FontLoaderService from "../controller/FontLoaderService";
import InitFontsTask from "../controller/InitFontsTask";
import PreloadFontsTask from "../controller/PreloadFontsTask";
import FontsConfig from "../model/FontsConfig";

export default class FontsInstaller extends AbstractInstaller {

    /**
     * @param {infuse.Injector} injector 
     * @param {soma.Commands} commands 
     * @param {MediatorMapping} mediatorMap 
     */
    constructor(injector, commands, mediatorMap) {
        super(injector, commands, mediatorMap);

        // assets
        this._addAssetsToConfigurationManifest(
            { id: "fonts", src: "assets/fonts.json", type: "json" }
        );

        // classes
        injector.mapClass("fontsConfig", FontsConfig, true);
        injector.mapClass("fontLoaderService", FontLoaderService, true);

        // tasks
        this._addStartupTask(InitFontsTask, "initFonts", 1);
        this._addStartupTask(PreloadFontsTask, "preloadFonts", 15, ["initFonts"]);
    }
}